// src/components/SectionWrapper.js
import React from 'react';
import { useInView } from 'react-intersection-observer';
import './SectionWrapper.css';

export default function SectionWrapper({ children, index }) {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const isEven = index % 2 === 0;

  return (
    <section
      ref={ref}
      className={`section-wrapper ${inView ? 'in-view' : ''} ${isEven ? 'dark-bg' : 'light-bg'}`}
    >
      <div className={`section-content ${isEven ? 'light-text' : 'dark-text'}`}>
        {children}
      </div>
    </section>
  );
}
